// extracted by mini-css-extract-plugin
export var standaloneTable = "_j6-0";
export var standaloneTableWithBodyFill = "_j6-1";
export var withExtraHeader = "_j6-2";